import React, {useEffect, useState} from "react";
import Map, {Layer, Source} from "react-map-gl";
import axios from "axios";



const WorldMapPreview = (props) => {
    const TOKEN = "pk.eyJ1IjoibGF2aWxhMTUwMSIsImEiOiJjbTV5aWZrdTgwNmozMnNzY212b2YyeXZsIn0.BHp4WIKhanAUWyYdU1ljGQ";
    const GOOGLE_API_KEY = "AIzaSyBDJ8jmcSbwaT00RajzJ7EXc4Nbr4JYZm4";
    const {width, height, backgroundColor, zoom } = props;
    const [geoJsonData, setGeoJsonData] = useState([]);
    const [addressGeolocation, setAddressGeolocation] = useState({lat:0, lng:0});
    const [template, setTemplate] = useState(props?.template);
    const [cityCoordinates, setCityCoordinates] = useState([]);
    const [coordinates, setCoordinates] = useState([]);

    function getCentralPoint() {
        if(props?.address){
            return {lat: -34.7075305, lng: -58.38812530000001, size: 10000};
        } else if (template === "manchester") {
            return { lat: 53.4831, lng: -2.2366 };
        } else if (template === "lfc") {
            return { lat: 53.4308, lng: -2.9608 };
        }  else if (template === "milan") {
            return { lat: 45.4642, lng: 9.1900 };
        } else if (template === "roma") {
            return { lat: 41.8923, lng: 12.4938 };
        } else if (template === "newyork") {
            return { lat: 40.7831, lng: -73.9712 };
        }

        return { lat: 0, lng: 0 };
    }
    function getCityCoordinates(template) {
        if (template === "manchester") {
            return {
                deansgate: { lat: 53.4776, lng: -2.2494, size: 1414 },
                ancoats: { lat: 53.4843, lng: -2.2309, size: 6283 },
                northernQuarter: { lat: 53.4831, lng: -2.2366, size: 2728 },
                spitalfields: { lat: 53.4705, lng: -2.2346, size: 5359 },
                cheethamHill: { lat: 53.5021, lng: -2.2403, size: 4127 },
                rusholme: { lat: 53.4548, lng: -2.2184, size: 2621 },
                whalleyRange: { lat: 53.4458, lng: -2.2611, size: 1310 },
                wythenshawe: { lat: 53.3886, lng: -2.2624, size: 4269 },
                didsbury: { lat: 53.4163, lng: -2.2316, size: 6372 },
                levenshulme: { lat: 53.4423, lng: -2.1937, size: 1540 },
                chorlton: { lat: 53.4403, lng: -2.2798, size: 4925 },
                stretford: { lat: 53.4505, lng: -2.3094, size: 3896 },
                paris: { lat: 48.8566, lng: 2.3522, size: 89 },
                berlin: { lat: 52.52, lng: 13.405, size: 156 },
                rome: { lat: 41.9028, lng: 12.4964, size: 134 },
                madrid: { lat: 40.4168, lng: -3.7038, size: 147 },
                amsterdam: { lat: 52.3676, lng: 4.9041, size: 91 },
                lisbon: { lat: 38.7169, lng: -9.1395, size: 123 },
                prague: { lat: 50.0755, lng: 14.4378, size: 112 },
                vienna: { lat: 48.2082, lng: 16.3738, size: 174 },
                brussels: { lat: 50.8503, lng: 4.3517, size: 185 },
                stockholm: { lat: 59.3293, lng: 18.0686, size: 99 },
                copenhagen: { lat: 55.6761, lng: 12.5683, size: 125 },
                oslo: { lat: 59.9139, lng: 10.7522, size: 116 },
                helsinki: { lat: 60.1695, lng: 24.9354, size: 89 },
                munich: { lat: 48.1351, lng: 11.582, size: 182 },
                zurich: { lat: 47.3769, lng: 8.5417, size: 133 },
            };
        } else if (template === "lfc") {
            return {
                liverpoolOne: { lat: 53.4034, lng: -2.9856, size: 1414 },
                balticTriangle: { lat: 53.3952, lng: -2.9785, size: 6283 },
                ropewalks: { lat: 53.4015, lng: -2.9796, size: 2728 },
                anfield: { lat: 53.4308, lng: -2.9608, size: 5359 },
                everton: { lat: 53.4279, lng: -2.9675, size: 4127 },
                toxteth: { lat: 53.3893, lng: -2.9676, size: 2621 },
                kensington: { lat: 53.4112, lng: -2.9487, size: 1310 },
                walton: { lat: 53.4499, lng: -2.9681, size: 4269 },
                woolton: { lat: 53.3739, lng: -2.8635, size: 6372 },
                aigburth: { lat: 53.3725, lng: -2.9361, size: 1540 },
                allerton: { lat: 53.3759, lng: -2.8854, size: 4925 },
                westDerby: { lat: 53.4379, lng: -2.8997, size: 3896 },
                paris: { lat: 48.8566, lng: 2.3522, size: 89 },
                berlin: { lat: 52.52, lng: 13.405, size: 156 },
                rome: { lat: 41.9028, lng: 12.4964, size: 134 },
                madrid: { lat: 40.4168, lng: -3.7038, size: 147 },
                amsterdam: { lat: 52.3676, lng: 4.9041, size: 91 },
                lisbon: { lat: 38.7169, lng: -9.1395, size: 123 },
                prague: { lat: 50.0755, lng: 14.4378, size: 112 },
                vienna: { lat: 48.2082, lng: 16.3738, size: 174 },
                brussels: { lat: 50.8503, lng: 4.3517, size: 185 },
                stockholm: { lat: 59.3293, lng: 18.0686, size: 99 },
                copenhagen: { lat: 55.6761, lng: 12.5683, size: 125 },
                oslo: { lat: 59.9139, lng: 10.7522, size: 116 },
                helsinki: { lat: 60.1695, lng: 24.9354, size: 89 },
                munich: { lat: 48.1351, lng: 11.582, size: 182 },
                zurich: { lat: 47.3769, lng: 8.5417, size: 133 },
            };
        } else if (template === "milan") {
            return {
                brera: { lat: 45.4729, lng: 9.1881, size: 1450 },
                navigli: { lat: 45.4501, lng: 9.1749, size: 3200 },
                portaVenezia: { lat: 45.4763, lng: 9.2052, size: 2890 },
                isola: { lat: 45.4856, lng: 9.1927, size: 5230 },
                portaRomana: { lat: 45.4538, lng: 9.2022, size: 4421 },
                cittaStudi: { lat: 45.4796, lng: 9.2253, size: 2670 },
                tortona: { lat: 45.4507, lng: 9.1598, size: 3815 },
                bovisa: { lat: 45.5061, lng: 9.1673, size: 1950 },
                lorenteggio: { lat: 45.4478, lng: 9.1336, size: 3287 },
                magenta: { lat: 45.4663, lng: 9.1755, size: 2760 },
                paris: { lat: 48.8566, lng: 2.3522, size: 89 },
                berlin: { lat: 52.52, lng: 13.405, size: 156 },
                madrid: { lat: 40.4168, lng: -3.7038, size: 147 },
                amsterdam: { lat: 52.3676, lng: 4.9041, size: 91 },
                lisbon: { lat: 38.7169, lng: -9.1395, size: 123 },
                prague: { lat: 50.0755, lng: 14.4378, size: 112 },
                vienna: { lat: 48.2082, lng: 16.3738, size: 174 },
                brussels: { lat: 50.8503, lng: 4.3517, size: 185 },
                stockholm: { lat: 59.3293, lng: 18.0686, size: 99 },
                copenhagen: { lat: 55.6761, lng: 12.5683, size: 125 },
                oslo: { lat: 59.9139, lng: 10.7522, size: 116 },
                helsinki: { lat: 60.1695, lng: 24.9354, size: 89 },
                munich: { lat: 48.1351, lng: 11.582, size: 182 },
                zurich: { lat: 47.3769, lng: 8.5417, size: 133 },
            };
        } else if (template === "roma") {
            return {
                trastevere: { lat: 41.8889, lng: 12.4663, size: 1450 },
                testaccio: { lat: 41.8776, lng: 12.4764, size: 3200 },
                monti: { lat: 41.8923, lng: 12.4938, size: 2890 },
                prati: { lat: 41.9095, lng: 12.4661, size: 5230 },
                esquilino: { lat: 41.8955, lng: 12.5019, size: 4421 },
                sanGiovanni: { lat: 41.8851, lng: 12.5223, size: 2670 },
                ostiense: { lat: 41.8606, lng: 12.4817, size: 3815 },
                nomentano: { lat: 41.9295, lng: 12.5169, size: 1950 },
                appioLatino: { lat: 41.8715, lng: 12.5159, size: 3287 },
                flaminio: { lat: 41.9234, lng: 12.4751, size: 2760 },
                paris: { lat: 48.8566, lng: 2.3522, size: 89 },
                berlin: { lat: 52.52, lng: 13.405, size: 156 },
                madrid: { lat: 40.4168, lng: -3.7038, size: 147 },
                amsterdam: { lat: 52.3676, lng: 4.9041, size: 91 },
                lisbon: { lat: 38.7169, lng: -9.1395, size: 123 },
                prague: { lat: 50.0755, lng: 14.4378, size: 112 },
                vienna: { lat: 48.2082, lng: 16.3738, size: 174 },
                brussels: { lat: 50.8503, lng: 4.3517, size: 185 },
                stockholm: { lat: 59.3293, lng: 18.0686, size: 99 },
                copenhagen: { lat: 55.6761, lng: 12.5683, size: 125 },
                oslo: { lat: 59.9139, lng: 10.7522, size: 116 },
                helsinki: { lat: 60.1695, lng: 24.9354, size: 89 },
                munich: { lat: 48.1351, lng: 11.582, size: 182 },
                zurich: { lat: 47.3769, lng: 8.5417, size: 133 },
            };
        } else if (template === "newyork") {
            return {
                manhattan: { lat: 40.7831, lng: -73.9712, size: 1600 },
                brooklyn: { lat: 40.6782, lng: -73.9442, size: 2500 },
                queens: { lat: 40.7282, lng: -73.7949, size: 2400 },
                bronx: { lat: 40.8448, lng: -73.8648, size: 1800 },
                statenIsland: { lat: 40.5795, lng: -74.1502, size: 1100 },
                harlem: { lat: 40.8116, lng: -73.9465, size: 1700 },
                chelsea: { lat: 40.7465, lng: -74.0014, size: 1500 },
                chinatown: { lat: 40.7158, lng: -73.9970, size: 1400 },
                williamsburg: { lat: 40.7081, lng: -73.9571, size: 2300 },
                dumbo: { lat: 40.7033, lng: -73.9881, size: 2200 },
                longIslandCity: { lat: 40.7470, lng: -73.9496, size: 2000 },
                flushing: { lat: 40.7675, lng: -73.8331, size: 2100 },
                astoria: { lat: 40.7644, lng: -73.9235, size: 1900 },
                jamaica: { lat: 40.7027, lng: -73.7899, size: 1800 },
                fordham: { lat: 40.8618, lng: -73.8943, size: 1700 },
                riverdale: { lat: 40.8906, lng: -73.9122, size: 1600 },
                coneyIsland: { lat: 40.5749, lng: -73.9850, size: 1400 },
                bayRidge: { lat: 40.6262, lng: -74.0321, size: 1300 },
                statenIslandNorth: { lat: 40.6301, lng: -74.1448, size: 1200 },
                statenIslandSouth: { lat: 40.5364, lng: -74.1917, size: 1100 },

                california: { lat: 36.7783, lng: -119.4179, size: 900 },
                texas: { lat: 31.9686, lng: -99.9018, size: 850 },
                florida: { lat: 27.9944, lng: -81.7603, size: 780 },
                illinois: { lat: 40.6331, lng: -89.3985, size: 800 },
                ohio: { lat: 40.4173, lng: -82.9071, size: 820 },
                georgia: { lat: 32.1656, lng: -82.9001, size: 730 },
                northCarolina: { lat: 35.7596, lng: -79.0193, size: 740 },
                michigan: { lat: 44.3148, lng: -85.6024, size: 720 },
            };
        }

        return {};
    }


    const getGeoJSONData = (arrayCities = cityCoordinates) => {
        const data = [];
        Object.entries(arrayCities).forEach(([city, coordinates]) => {
            data.push({
                type: "Feature",
                geometry: {
                    type: "Point",
                    coordinates: [coordinates.lng, coordinates.lat],
                },
                properties: {
                    city,
                    size: coordinates.size,
                },
            });
        });
        return data;
    };

    const getCoordinates = async () => {
        try {
            if(props.address){
                const response = await axios.get(
                    `https://maps.googleapis.com/maps/api/geocode/json`,
                    {
                        params: {
                            address: props?.address ?? '',
                            key: GOOGLE_API_KEY,
                        },
                    }
                );

                if (response.data.results && response.data.results.length > 0) {
                    const location = response.data.results[0].geometry.location;
                    setGeoJsonData(getGeoJSONData({
                        home: { lat: location.lat, lng: location.lng, size: 10000 },
                    }));
                    setAddressGeolocation({ lat: location.lat, lng: location.lng, size: 10000 });
                    setCoordinates({ lat: location.lat, lng: location.lng });
                } else {
                    // Fallback: usar coordenadas por defecto cuando la API falla
                    const fallback = getCentralPoint();
                    setGeoJsonData(getGeoJSONData({
                        home: { lat: fallback.lat, lng: fallback.lng, size: 10000 },
                    }));
                    setAddressGeolocation({ lat: fallback.lat, lng: fallback.lng, size: 10000 });
                    setCoordinates({ lat: fallback.lat, lng: fallback.lng });
                }
            } else {
                setCoordinates(getCentralPoint(template));
                setCityCoordinates(getCityCoordinates(template));
                setGeoJsonData(getGeoJSONData(getCityCoordinates(template)));
            }

        } catch (error) {
            // Fallback en caso de error de red
            const fallback = getCentralPoint();
            setCoordinates({ lat: fallback.lat, lng: fallback.lng });
            setGeoJsonData(getGeoJSONData({
                home: { lat: fallback.lat, lng: fallback.lng, size: 10000 },
            }));
        }
    };



    // Cargar los datos GeoJSON al montar el componente
    useEffect(() => {
        setGeoJsonData(getGeoJSONData());
        getCoordinates();
        setCityCoordinates(getCityCoordinates(template));
    }, [props.address]);


    function getColor(template) {
        if (template === "manchester") {
            return "#00175b";
        } else if (template === "lfc") {
            return "#D1202A";
        } else if (template === "milan") {
            return "#E50027";
        }  else if (template === "roma") {
            return "#97132C";
        } else if (template === "newyork") {
            return "#FC2436";
        }
        return "#000000";
    }

    function getColorSecondary(template) {
        if (template === "manchester") {
            return "#51bbd6";
        } else if (template === "lfc") {
            return "#D1202A";
        }else if (template === "milan") {
            return "#E50027";
        } else if (template === "roma") {
            return "#FBBA00";
        } else if (template === "newyork") {
            return "#1D2855";
        }
        return "#000000";
    }

    return (
        <>
            {coordinates.lat !== undefined && coordinates.lng !== undefined && (
                <div style={{
                    width: width===0 ? '100%' : width,
                    height: height===0 ? '100%' : height,
                    backgroundColor : backgroundColor
                }}>
                    <Map
                        initialViewState={{
                            latitude:coordinates?.lat,
                            longitude: coordinates?.lng,
                            zoom: (zoom) ,
                        }}
                        style={{ width: width===0 ? '100%' : width, height: height===0 ? '100%' : height}}
                        mapStyle="mapbox://styles/mapbox/streets-v11"
                        mapboxAccessToken={TOKEN}
                    >
                        {/* Fuente GeoJSON */}
                        <Source id="cities" type="geojson" data={{ type: "FeatureCollection", features: geoJsonData }}>
                            <Layer
                                id="clusters"
                                type="circle"
                                source="cities"
                                filter={["has", "point_count"]}
                                paint={{
                                    "circle-color": getColorSecondary(template),
                                    "circle-radius": [
                                        "step",
                                        ["get", "point_count"],
                                        20,
                                        100,
                                        30,
                                        750,
                                        40,
                                    ],
                                    "circle-opacity": 0.6,
                                }}
                            />
                            <Layer
                                id="cluster-count"
                                type="symbol"
                                source="cities"
                                filter={["has", "point_count"]}
                                layout={{
                                    "text-field": "{point_count_abbreviated}",
                                    "text-font": ["Roboto", "Arial Unicode MS Regular"],
                                    "text-size": 12,
                                }}
                                paint={{
                                    "text-color": "#ffffff",
                                }}
                            />
                        </Source>

                        {/* Puntos individuales con tamaño dinámico */}
                        <Source id="individual" type="geojson" data={{ type: "FeatureCollection", features: geoJsonData }}>
                            <Layer
                                id="unclustered-point"
                                type="circle"
                                source="individual"
                                filter={["!has", "point_count"]}
                                paint={{
                                    "circle-color": getColor(template),
                                    "circle-radius": [
                                        "interpolate",
                                        ["linear"],
                                        ["get", "size"],  // Usar el valor de "size" para el radio
                                        1000,  // Valor mínimo de size
                                        5,    // Radio mínimo
                                        3000, // Valor máximo de size
                                        30    // Radio máximo
                                    ],
                                    "circle-opacity": 0.7,
                                }}
                            />
                        </Source>
                    </Map>
                </div>
            )}
        </>
    );
};

export default WorldMapPreview;
